import Angular from "angular";
import Controller from "./dashboard.controller";
import Template from "./dashboard.html";
import Bookings from "../../services/bookings.service";
import Workloads from "../../services/workload.service";
import WeekDateSelection from "../../components/week-date-selection/week-date-selection";
import ChartBookingProgress from "../../components/chart-booking-progress/chart-booking-progress";
import ChartBookingWorkload from "../../components/chart-booking-workload/chart-booking-workload";
import ChartBookingServices from "../../components/chart-booking-services/chart-booking-services";
import ChartBookingResources from "../../components/chart-booking-resources/chart-booking-resources";
import ChartResourceWorkloads from "../../components/chart-resource-workload/chart-resource-workload";
import ChartWorkloadColors from "../../components/chart-workload-colors/chart-workload-colors";
import ChartWorkloadColorsMap from "../../components/chart-workload-colors-map/chart-workload-colors-map";

export const DashboardView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.dashboard', [
    Bookings.name,
    Workloads.name,
    WeekDateSelection.name,
    ChartBookingProgress.name,
    ChartBookingWorkload.name,
    ChartBookingServices.name,
    ChartBookingResources.name,
    ChartResourceWorkloads.name,
    ChartWorkloadColors.name,
    ChartWorkloadColorsMap.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/dashboard/dashboard.js